import React from 'react';
import DEFAULTS from '../constants/pricing/defaults';

const PricingContext = React.createContext(
  JSON.parse(JSON.stringify(DEFAULTS))
);

export default PricingContext;
